export function dateLocalize(utcDate?: string | null): string {
    if (!utcDate) return '---'
    return new Date(utcDate + 'Z').toLocaleString('sv-SE')
}
